import { Link } from 'react-router-dom';
import riwaazImage from '../../assets/images/events/riwaaz/riwaaz.png';
import yplix from '../../assets/images/yplix/yplix.jpeg';
import './Events.css';

const Events = () => {
  return (
    <div className="events-page py-5">
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-10">

            <div className="banner-card overflow-hidden">

              <div className="text-center p-4 pb-0">
                <img
                  src={riwaazImage}
                  alt="Riwaaz - The Culture of India"
                  className="img-fluid banner-image"
                />
              </div>

              <div className="card-body p-4 p-lg-5 text-white">

                <div className="text-center mb-4">
                  <span className="badge event-badge px-3 py-2 rounded-pill">
                    Reality Show 2026
                  </span>

                  <h2 className="display-6 fw-bold mt-3 mb-2">
                    Riwaaz – The Culture of India
                  </h2>

                  <p className="lead text-warning fw-semibold mb-0">
                    Bharat Ki Sanskriti Ka MahaKumbh
                  </p>
                </div>

                <p className="text-white-50 fs-5">
                  <strong className="text-white">
                    Riwaaz – The Culture of India
                  </strong>{' '}
                  is a grand cultural reality show dedicated to discovering,
                  celebrating, and promoting talented individuals from every
                  corner of India.
                </p>

                <p className="text-white-50 fs-5">
                  This unique platform brings together contestants from across
                  the country to showcase India's rich heritage through
                  traditional costumes, fashion, dance, music, art, and cultural
                  performances.
                </p>

                <p className="text-white-50 fs-5 mb-5">
                  Experience India's vibrant traditions on one national stage,
                  where talent meets culture and diversity becomes the true
                  celebration of our nation.
                </p>

                <div className="row g-4 mb-5">

                  <div className="col-md-4">
                    <div className="info-box h-100 text-center p-4 rounded-4">
                      <div className="fs-1 mb-2">📍</div>
                      <h6 className="fw-bold text-warning">Venue</h6>
                      <p className="mb-0 text-white-50">
                        Goa, India
                      </p>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="info-box h-100 text-center p-4 rounded-4">
                      <div className="fs-1 mb-2">🎥</div>
                      <h6 className="fw-bold text-warning">
                        Shoot Location
                      </h6>
                      <p className="mb-0 text-white-50">
                        Goa
                      </p>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="info-box h-100 text-center p-4 rounded-4">
                      <img
                        src={yplix}
                        alt="YPix OTT"
                        className="img-fluid yplix-logo mb-3"
                      />

                      <h6 className="fw-bold text-warning mb-2">
                        Streaming Partner
                      </h6>

                      <p className="mb-1 text-white-50">
                        Exclusively Streaming
                      </p>
                    </div>
                  </div>

                </div>

                <div className="mb-5">
                  <h3 className="fw-bold text-warning text-center mb-4">
                    Show Highlights
                  </h3>

                  <div className="row g-3">

                    {[
                      'National Level Cultural Reality Show',
                      'Traditional & Modern Fashion Showcase',
                      'Dance Performances',
                      'Music & Singing',
                      'Art & Creative Talent',
                      'Contestants from Across India',
                      "Celebrate India's Heritage & Diversity",
                      'National OTT Streaming'
                    ].map((item, index) => (
                      <div className="col-md-6" key={index}>
                        <div className="highlight-box rounded-3 p-3 h-100">
                          ✨ {item}
                        </div>
                      </div>
                    ))}

                  </div>
                </div>

                <div className="text-center">
                  <Link
                    to="/registration"
                    className="btn btn-register btn-lg px-5 py-3 rounded-pill fw-bold"
                  >
                    Register Now
                  </Link>
                </div>

              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Events;